import { render } from "./brandIcons.vue?vue&type=template&id=80b3fa72&scoped=true"
import script from "./brandIcons.vue?vue&type=script&lang=js"
export * from "./brandIcons.vue?vue&type=script&lang=js"

import "./brandIcons.vue?vue&type=style&index=0&id=80b3fa72&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80b3fa72"]])

export default __exports__